document.addEventListener('DOMContentLoaded', () => {
  const jsGlobalHeader = document.querySelector('.js-global-header');
  const hamburgerToggleButton = document.querySelector('.js-global-header-toggle-button');
  const planLink = document.querySelector('.js-global-header-plan');
  const planItems = document.querySelector('.js-global-header-plan-items');
  const overlay = document.querySelector('.js-global-header-overlay');

  if (!jsGlobalHeader || !hamburgerToggleButton || !planLink || !planItems || !overlay) {
    return;
  }

  const isEmbedded = window.self !== window.top;
  const PC_BREAKPOINT = 768;
  const MENU_CLOSE_DELAY = 200;
  let lastScrollTop = 0;
  const headerHeight = jsGlobalHeader.offsetHeight;
  let menuCloseTimeout;
  let scrollY = 0;

  const notifyEmbeddedMenuState = (open) => {
    if (!isEmbedded) return;

    window.parent.postMessage({
      type: 'embed-menu-state',
      open,
    }, '*');
  };

  /**
   * モバイル用のメニューを開閉
   */
  const togglePlanMenu = () => {
    jsGlobalHeader.classList.toggle('-active');
    hamburgerToggleButton.classList.toggle('-active');
    planItems.classList.toggle('is-visible');
    overlay.classList.toggle('is-visible');

    notifyEmbeddedMenuState(overlay.classList.contains('is-visible') && window.innerWidth <= PC_BREAKPOINT);

    if (overlay.classList.contains('is-visible')) {
      // スクロール位置を保存し、bodyを固定
      scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
    } else {
      // 固定解除し、元の位置に戻す
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (!isEmbedded) {
        window.scrollTo(0, scrollY);
      }
    }
  };

  /**
   * PC表示でプランメニューを開く
   */
  const openPlanMenuPC = () => {
    clearTimeout(menuCloseTimeout);
    planItems.classList.add('is-visible');
    overlay.classList.add('is-visible');
    jsGlobalHeader.classList.add('-active');
    hamburgerToggleButton.classList.add('-active');
  };

  /**
   * PC表示でプランメニューを閉じます。
   */
  const closePlanMenuPC = () => {
    planItems.classList.remove('is-visible');
    overlay.classList.remove('is-visible');
    jsGlobalHeader.classList.remove('-active');
    hamburgerToggleButton.classList.remove('-active');
    notifyEmbeddedMenuState(false);
  };

  /**
   * 少し遅れてPC表示のプランメニューを閉じる
   */
  const scheduleClosePlanMenuPC = () => {
    menuCloseTimeout = setTimeout(closePlanMenuPC, MENU_CLOSE_DELAY);
  };

  hamburgerToggleButton.addEventListener('click', togglePlanMenu);

  overlay.addEventListener('click', () => {
    if (window.innerWidth <= PC_BREAKPOINT) {
      togglePlanMenu();
    } else {
      closePlanMenuPC();
    }
  });


  const handleDesktopMenuOpen = () => {
    if (window.innerWidth > PC_BREAKPOINT) {
      openPlanMenuPC();
    }
  };

  const handleDesktopMenuClose = () => {
    if (window.innerWidth > PC_BREAKPOINT) {
      scheduleClosePlanMenuPC();
    }
  };

  const handleDesktopMenuClearTimeout = () => {
    if (window.innerWidth > PC_BREAKPOINT) {
      clearTimeout(menuCloseTimeout);
    }
  };

  planLink.addEventListener('mouseenter', handleDesktopMenuOpen);
  planLink.addEventListener('focus', handleDesktopMenuOpen);

  planLink.addEventListener('mouseleave', handleDesktopMenuClose);
  planItems.addEventListener('mouseenter', handleDesktopMenuClearTimeout);
  planItems.addEventListener('focusin', handleDesktopMenuClearTimeout);
  planItems.addEventListener('mouseleave', handleDesktopMenuClose);

  planLink.addEventListener('click', (event) => {
    if (window.innerWidth <= PC_BREAKPOINT) {
      event.preventDefault();
      togglePlanMenu();
    }
  });

  const menuContainer = document.querySelector('.global-header-inner');
  let touchStartY = 0;

  menuContainer.addEventListener('touchstart', (e) => {
    if (jsGlobalHeader.classList.contains('-active') && window.innerWidth <= PC_BREAKPOINT) {
      touchStartY = e.touches[0].clientY;
    }
  }, { passive: true });

  menuContainer.addEventListener('touchmove', (e) => {
    if (!jsGlobalHeader.classList.contains('-active') || window.innerWidth > PC_BREAKPOINT) {
      return;
    }

    const currentY = e.touches[0].clientY;
    const isScrollingUp = currentY > touchStartY;
    const isScrollingDown = currentY < touchStartY;

    const isAtTop = menuContainer.scrollTop === 0;
    const isAtBottom = menuContainer.scrollHeight - menuContainer.scrollTop <= menuContainer.clientHeight + 1;

    if ((isAtTop && isScrollingUp) || (isAtBottom && isScrollingDown)) {
      e.preventDefault();
    }
  }, { passive: false });

  window.addEventListener('scroll', () => {
    if (isEmbedded) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (jsGlobalHeader.classList.contains('-active')) {
      return;
    }

    if (scrollTop > lastScrollTop && scrollTop > headerHeight) {
      jsGlobalHeader.classList.add('is-hidden');
    } else {
      jsGlobalHeader.classList.remove('is-hidden');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }, false);

  window.addEventListener('resize', () => {
    if (!isEmbedded) return;

    // モバイル幅以外では親側のスクロールロックを解除する
    if (window.innerWidth > PC_BREAKPOINT) {
      notifyEmbeddedMenuState(false);
    }
  });
});
